import React from "react";
import PropTypes from "prop-types";
import FileIcon from "../../../ui/icons/FileIcon";
import ShareIcon from "../../../ui/icons/ShareIcon";
import FlagIcon from "../../../ui/icons/FlagIcon";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { TAB_HEADERS, TAB_NAMES } from "./constants";

export default function PatientShareCardHeader(props) {
    function handleTabClick(tab) {
        if (props.openTab !== tab) {
            props.onTabChange(tab);
        }
    }

    const renderTooltip = (tooltipProps) => (
        <Tooltip id="sidebar-quality-tooltip" {...tooltipProps}>
            {props.tooltipText}
        </Tooltip>
    );

    return (
        <div className="text-primary-500 flex h-14 w-full items-center justify-between rounded-t-lg border-b-2 border-b-neutral-50 text-xl">
            <div
                id="sidebar-plan-details-tab"
                className={`hover:bg-primary-500/10 flex h-full w-[45%] cursor-pointer items-center justify-center rounded-tl-lg border-b-4 pt-1 ${props.openTab === TAB_NAMES.PLAN ? "border-primary-500" : "border-transparent"}`}
                onClick={() => handleTabClick(TAB_NAMES.PLAN)}
            >
                <div className="flex items-center justify-center gap-3">
                    <FileIcon />
                    {TAB_HEADERS.CASE_DETAILS}
                </div>
            </div>
            <div
                id="sidebar-share-and-notes-tab"
                className={`hover:bg-primary-500/10 flex h-full w-[45%] cursor-pointer justify-center border-b-4 ${props.openTab === TAB_NAMES.NOTES ? "border-primary-500" : "border-transparent"}`}
                onClick={() => handleTabClick(TAB_NAMES.NOTES)}
            >
                <div className="flex items-center justify-center gap-3 pt-1">
                    <ShareIcon />
                    {TAB_HEADERS.SHARE_AND_NOTES}
                </div>
            </div>
            <div
                id="sidebar-qualify-flag-hover"
                className="flex w-[10%] items-center justify-center"
            >
                {props?.hasFlag && (
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                    >
                        <div>
                            <FlagIcon />
                        </div>
                    </OverlayTrigger>
                )}
            </div>
        </div>
    );
}

PatientShareCardHeader.propTypes = {
    openTab: PropTypes.oneOf([TAB_NAMES.PLAN, TAB_NAMES.NOTES]).isRequired,
    onTabChange: PropTypes.func.isRequired,
    tooltipText: PropTypes.string,
    hasFlag: PropTypes.bool,
};
